/* eslint-disable no-undef, symbol-description */

/** List of weak references to objects that can be obtained by .getAll(). */
class WeakList {
	constructor() {
		this.refs = [];
		if (typeof FinalizationRegistry === 'undefined' || typeof WeakRef === 'undefined') {
			// For old browsers - let's leak some memory by never removing the references
			Object.assign(this, {
				add: (obj) => { this.refs.push(obj); },
				getAll: () => [...this.refs],
			});
		}
		this.cleanup = new FinalizationRegistry((uniqVal) => {
			this.refs = this.refs.filter((ref) => ref.uniqVal !== uniqVal);
		});
	}

	add(obj) {
		if (this.getAll().includes(obj)) {
			return;
		}
		const ref = new WeakRef(obj);
		const uniqVal = Symbol();
		this.refs.push({ ref, uniqVal });
		this.cleanup.register(obj, uniqVal);
	}

	getAll() {
		return this.refs.map(({ ref }) => ref.deref()).filter(Boolean);
	}
}

module.exports = WeakList;
